import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";
import { Button } from "react-aria-components";

import {
  formatResourceRefreshTime,
  type ConversationResourceGate,
} from "@/features/chat/resourceAvailability";

gsap.registerPlugin(useGSAP);

export function ConversationResourceLimitResult({
  currentRefreshesAt,
  gate,
  isRetrying,
  onRetry,
}: {
  currentRefreshesAt?: string | null;
  gate: ConversationResourceGate;
  isRetrying: boolean;
  onRetry: () => void;
}) {
  const rootRef = useRef<HTMLDivElement>(null);
  const refreshesAt =
    gate.type === "data-resource-limit"
      ? currentRefreshesAt ?? gate.data.refreshesAt
      : null;
  const refreshLabel = formatResourceRefreshTime(refreshesAt);

  useGSAP(
    () => {
      const root = rootRef.current;
      if (!root || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }
      gsap.fromTo(
        root,
        { autoAlpha: 0, height: 0 },
        {
          autoAlpha: 1,
          clearProps: "height,opacity,visibility,willChange",
          duration: 0.22,
          ease: "power2.out",
          height: "auto",
        },
      );
    },
    { scope: rootRef },
  );

  return (
    <div
      className="conversation-resource-limit"
      data-resource-gate-type={gate.type}
      ref={rootRef}
      role="status"
    >
      <Button
        className="conversation-resource-limit__retry"
        isDisabled={isRetrying}
        onPress={onRetry}
      >
        {isRetrying ? "正在检查…" : "重试"}
      </Button>
      <p>
        {gate.type === "data-resource-limit" ? (
          <>
            你目前已用完 AI 使用额度。请充值获取更多额度
            {refreshLabel ? `，或在 ${refreshLabel} 后重试以继续` : "，充值后即可重试"}
          </>
        ) : (
          "暂时无法确认 AI 使用额度，请稍后重试。本轮未产生模型或工具费用。"
        )}
      </p>
    </div>
  );
}
